import { Slider } from "@/components/ui/slider";
import { Move } from "lucide-react";

const SPOTS = [["top", "Top", 0.14], ["middle", "Middle", 0.5], ["bottom", "Bottom", 0.86]];

// Position + opacity for the selected caption(s) only — writes per-object posX/posY/opacity.
export const CaptionPlacement = ({ obj, count = 1, onPatch, onPatchEnd, defaultY = 0.72 }) => {
  const x = obj.posX ?? 0.5, y = obj.posY ?? defaultY, op = obj.opacity ?? 1;
  const row = (label, val, testid, v, set, min = 0, max = 1) => (
    <div className="flex items-center gap-2">
      <span className="w-14 shrink-0 text-[11px] text-[#A1A1AA]">{label}</span>
      <Slider data-testid={testid} value={[v]} min={min} max={max} step={0.01} onValueChange={([n]) => set(n)} onValueCommit={() => onPatchEnd && onPatchEnd()} className="flex-1" />
      <span className="w-9 shrink-0 text-right font-plex text-[11px] tabular-nums text-white">{val}</span>
    </div>
  );
  return (
    <div className="w-full space-y-2 rounded-lg border border-white/10 bg-white/[0.02] p-2.5" data-testid="caption-placement">
      <div className="flex items-center justify-between">
        <span className="flex items-center gap-1 text-[10px] font-bold uppercase tracking-wide text-[#A1A1AA]"><Move size={11} className="text-[#00F0FF]" /> Position {count > 1 ? `· ${count} captions` : "· this caption"}</span>
        <div className="flex gap-1">
          {SPOTS.map(([k, l, py]) => (
            <button key={k} type="button" onClick={() => onPatch({ posY: py })} data-testid={`caption-pos-${k}`}
              className={`rounded-md border px-2 py-0.5 text-[11px] font-semibold transition-colors ${Math.abs(y - py) < 0.02 ? "border-[#00F0FF] bg-[#00F0FF]/15 text-[#00F0FF]" : "border-white/15 text-[#A1A1AA] hover:text-white"}`}>{l}</button>
          ))}
        </div>
      </div>
      {row("Left ↔", `${Math.round(x * 100)}%`, "caption-pos-x-slider", x, (n) => onPatch({ posX: n }, true))}
      {row("Up ↕", `${Math.round(y * 100)}%`, "caption-pos-y-slider", y, (n) => onPatch({ posY: n }, true))}
      {row("Opacity", `${Math.round(op * 100)}%`, "caption-opacity-slider", op, (n) => onPatch({ opacity: n }, true))}
    </div>
  );
};
